<template>
  <div class="px-4 sm:px-0 mb-2 sticky z-10 bg-app top-0">
    <router-link :to="{ name: to }" class="inline-flex rounded transition-all duration-150 items-center hover:px-4 py-2 hover:bg-secondary-100 text-secondary hover:text-secondary-500">
      <base-icon size="sm" name="arrowleft" />
      <span>Atrás</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    to: {
      type: String,
      default: 'options'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
